import { lazy } from 'solid-js'
import { messages } from '../../pages/checkout-confirmation-page/checkout-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/checkout-confirmation-page/checkout-confirmation-page.jsx')),
    lockCurrencySelection: true,
    path: '/checkout/:booking_id?',
    showFooter: false,
    showHeaderMenu: false,
    showUserHeader: true,
    titleMessage: messages.titleMessage,
}
